import { useState } from "react";
import { useUpdateCustomTaxRelief } from "../../../../../../services/custom-tax-relief.service";
import { CustomTaxReliefDto } from "../../../../../../models/custom-tax-relief.dto";

interface IAssignedTaxReliefRow {
	employeeId: number;
	relief: CustomTaxReliefDto;
	onRemoved: () => void;
}

const AssignedTaxReliefRow = ({
	employeeId,
	relief,
	onRemoved,
}: IAssignedTaxReliefRow) => {
	const [confirming, setConfirming] = useState(false);
	const [removing, setRemoving] = useState(false);
	const { mutate: updateCustomTaxRelief } = useUpdateCustomTaxRelief();

	const handleRemove = () => {
		setRemoving(true);

		updateCustomTaxRelief(
			{
				id: relief.id,
				payload: {
					removeEmployeeIds: [employeeId],
				},
			},
			{
				onSuccess: () => onRemoved(),
				onSettled: () => setRemoving(false),
			},
		);
	};

	return (
		<div className="border border-gray-300 rounded-lg px-5 py-4">
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-6">
					<div>
						<p className="text-xs text-gray-400 mb-0.5">Code</p>
						<p className="text-sm font-medium">{relief.code}</p>
					</div>
					<div>
						<p className="text-xs text-gray-400 mb-0.5">Name</p>
						<p className="text-sm font-medium">{relief.name}</p>
					</div>
					<div>
						<p className="text-xs text-gray-400 mb-0.5">Amount</p>
						<p className="text-sm font-medium">
							{relief.amount != null ? relief.amount.toLocaleString() : "—"}
						</p>
					</div>
					{relief.group && (
						<div>
							<p className="text-xs text-gray-400 mb-0.5">Group</p>
							<p className="text-sm font-medium">{relief.group.name}</p>
						</div>
					)}
					<span
						className={`inline-block text-xs px-2 py-1 rounded-full font-medium ${
							relief.active
								? "bg-green-100 text-green-700"
								: "bg-red-100 text-red-600"
						}`}
					>
						{relief.active ? "Active" : "Inactive"}
					</span>
				</div>

				{!confirming && (
					<button
						type="button"
						onClick={() => setConfirming(true)}
						className="px-6 py-2.5 border border-gray-300 text-gray-600 hover:text-red-500 hover:border-red-300 rounded-lg text-2xs transition-colors shrink-0"
					>
						Remove
					</button>
				)}
			</div>

			{confirming && (
				<div className="mt-3 pt-3 border-t border-gray-200 flex items-center justify-between">
					<p className="text-sm text-gray-600">
						Unassign <span className="font-semibold">{relief.name}</span> from
						this employee?
					</p>
					<div className="flex items-center gap-3">
						<button
							type="button"
							onClick={() => setConfirming(false)}
							disabled={removing}
							className="px-5 py-2 border border-gray-300 text-gray-500 rounded-lg text-2xs disabled:opacity-50"
						>
							Cancel
						</button>
						<button
							type="button"
							onClick={handleRemove}
							disabled={removing}
							className="px-5 py-2 bg-secondary-red text-white rounded-lg text-2xs hover:shadow-sm disabled:opacity-50"
						>
							{removing ? "Removing..." : "Yes, Unassign"}
						</button>
					</div>
				</div>
			)}
		</div>
	);
};

export default AssignedTaxReliefRow;
